"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5904],{

/***/ 15904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PublicationSlug; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./config/routes.tsx + 2 modules
var routes = __webpack_require__(6635);
// EXTERNAL MODULE: ./node_modules/@cloudinary/transformation-builder-sdk/actions/resize.js + 36 modules
var resize = __webpack_require__(12073);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/basic/AvatarPartager/index.tsx
var AvatarPartager = __webpack_require__(99465);
// EXTERNAL MODULE: ./components/elements/Button/index.tsx
var Button = __webpack_require__(74340);
// EXTERNAL MODULE: ./components/modules/Layout/BasicLayout/index.tsx
var BasicLayout = __webpack_require__(87097);
// EXTERNAL MODULE: ./components/modules/Seo/index.tsx
var Seo = __webpack_require__(12400);
// EXTERNAL MODULE: ./components/modules/SubscriberForm/index.tsx + 2 modules
var SubscriberForm = __webpack_require__(65773);
// EXTERNAL MODULE: ./features/publication/components/PublicationLanding/publicationLanding.service.ts
var publicationLanding_service = __webpack_require__(46319);
;// CONCATENATED MODULE: ./features/publication/components/PublicationLanding/index.tsx










function PublicationLanding(param) {
    var publication = param.publication, setIsShowPublicationPosts = param.setIsShowPublicationPosts;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BasicLayout/* default */.Z, {
        className: "bg-transparent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* default */.Z, {
                title: publication.title,
                description: publication.description,
                image: (ref = publication.logo) === null || ref === void 0 ? void 0 : ref.url,
                type: "publication",
                url: routes/* default.publicationSlug.getUrl */.Z.publicationSlug.getUrl(publication.slug),
                author: publication.user.pseudoName,
                createdAt: publication.createdAt,
                thematic: publication.thematic
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "shortcut icon",
                    href: (ref1 = publication.logo) === null || ref1 === void 0 ? void 0 : ref1.url
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "m-auto p-4 md:p-0 text-center max-w-md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarPartager/* default */.Z, {
                        provider_metadata: (ref2 = publication.logo) === null || ref2 === void 0 ? void 0 : ref2.provider_metadata,
                        resizeParameters: (0,resize/* fill */.hl)().width(160).height(160),
                        name: publication.title,
                        size: 20,
                        square: true,
                        className: "mx-auto mb-10"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriberForm/* default */.Z, {
                        publication: publication,
                        horizontalInput: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                        color: "link",
                        type: "button",
                        onClick: function() {
                            (0,publicationLanding_service/* updateShowPublicationPosts */.L)(publication.id, true);
                            setIsShowPublicationPosts(true);
                        },
                        children: "Laissez moi lire d'abord"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./components/modules/Navigation/Tabs/index.tsx + 1 modules
var Tabs = __webpack_require__(94643);
// EXTERNAL MODULE: ./components/modules/SubscribeBanner/index.tsx
var SubscribeBanner = __webpack_require__(42995);
// EXTERNAL MODULE: ./lib/hooks/useInfiniteScroll.ts
var useInfiniteScroll = __webpack_require__(85047);
// EXTERNAL MODULE: ./features/post/index.ts + 1 modules
var post = __webpack_require__(1485);
// EXTERNAL MODULE: ./components/basic/Containers/ContainerMedium/index.tsx
var ContainerMedium = __webpack_require__(16169);
// EXTERNAL MODULE: ./components/Tiptap/index.tsx + 5 modules
var Tiptap = __webpack_require__(2886);
// EXTERNAL MODULE: ./components/Tiptap/useEditorInstance.ts
var useEditorInstance = __webpack_require__(59611);
;// CONCATENATED MODULE: ./features/publication/components/PublicationAbout/index.tsx




function PublicationAbout(param) {
    var publication = param.publication;
    var tiptap = (0,useEditorInstance/* default */.Z)({
        readOnly: true,
        content: publication.about && JSON.parse(publication.about)
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerMedium/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tiptap/* default */.Z, {
            editor: tiptap
        })
    });
}

// EXTERNAL MODULE: ./components/basic/Modal/index.tsx + 1 modules
var Modal = __webpack_require__(98778);
// EXTERNAL MODULE: ./components/elements/Paragraph/index.tsx
var Paragraph = __webpack_require__(99730);
// EXTERNAL MODULE: ./components/modules/Posts/PostTeaser/index.tsx
var PostTeaser = __webpack_require__(79114);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/lock-fill.svg
var lock_fill = __webpack_require__(18342);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/reply.svg
var reply = __webpack_require__(64036);
// EXTERNAL MODULE: ./features/publication/components/PublicationPosts/PublicationPosts.service.ts
var PublicationPosts_service = __webpack_require__(78532);
// EXTERNAL MODULE: ./lib/helper/date-helper.ts
var date_helper = __webpack_require__(23940);
// EXTERNAL MODULE: ./lib/helper/post-helper.ts + 3 modules
var post_helper = __webpack_require__(93367);
// EXTERNAL MODULE: ./lib/hooks/likeHook.ts + 3 modules
var likeHook = __webpack_require__(16089);
// EXTERNAL MODULE: ./components/basic/CommentCounter/index.tsx
var CommentCounter = __webpack_require__(24897);
// EXTERNAL MODULE: ./components/basic/LikeCounter/index.tsx
var LikeCounter = __webpack_require__(83539);
// EXTERNAL MODULE: ./components/elements/Heading/Heading1/index.tsx
var Heading1 = __webpack_require__(7211);
// EXTERNAL MODULE: ./components/elements/Link/index.tsx
var Link = __webpack_require__(6553);
// EXTERNAL MODULE: ./components/ImageCloudinary/index.tsx
var ImageCloudinary = __webpack_require__(43894);
;// CONCATENATED MODULE: ./components/modules/Posts/PostTeaserBig/index.tsx


















function PostTeaserBig(param) {
    var post = param.post, publication = param.publication, user = param.user, onClickShare = param.onClickShare, domain = param.domain;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,likeHook/* default */.Z)({
        postId: post.id,
        likesProp: post.actions
    }), 3), totalLikes = ref1[0], isLiked = ref1[1], onLikeClick = ref1[2];
    var relativePath = (0,PublicationPosts_service/* getRelativePath */.L)(domain, publication.slug, post.id);
    var _slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: "relative flex flex-col md:flex-row auto-cols-mins mb-4 md:mb-12 lg:mb-16 p-4 lg:hover:bg-gray-50 lg:dark:hover:bg-gray-700 rounded-2xl",
        children: [
            ((ref = post.cover) === null || ref === void 0 ? void 0 : ref.provider_metadata) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: relativePath,
                className: "hidden md:block mr-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCloudinary/* default */.Z, {
                    provider_metadata: post.cover.provider_metadata,
                    alt: post.title,
                    resizeParameters: (0,resize/* fill */.hl)().width(1540),
                    className: "aspect-video"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col grow p-4 md:p-0 md:pl-4 lg:pl-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        type: "alternative",
                        href: relativePath,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading1/* default */.Z, {
                            className: "!mt-0",
                            children: post.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                        variant: "frontend",
                        children: post.subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row text-gray-500 text-sm whitespace-nowrap mt-6 lg:mt-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                type: "alternative",
                                href: routes/* default.getUser.getUrl */.Z.getUser.getUrl((_slug = user.slug) !== null && _slug !== void 0 ? _slug : user.id),
                                className: "flex flex-row space-x-2 mr-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-bold text-gray-800 dark:text-white",
                                    children: user.pseudoName
                                })
                            }),
                            (0,post_helper/* isPostHasPaywall */.D3)(post.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mr-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "md:inline-flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lock_fill/* default */.Z, {
                                        className: "w-[15px] h-[15px]"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mr-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "hidden md:inline-flex",
                                    children: (0,date_helper/* formatDateRelative */.Km)(post.createdAt)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row ml-auto",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LikeCounter/* default */.Z, {
                                        count: totalLikes,
                                        liked: isLiked,
                                        onClick: function() {
                                            return onLikeClick();
                                        },
                                        className: "mr-4 mt-1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentCounter/* default */.Z, {
                                        count: post.totalComments || 0,
                                        className: "font-normal"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                        color: "link",
                                        onClick: function() {
                                            return onClickShare(post.id);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(reply/* default */.Z, {
                                            className: "-scale-x-100"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/svgs/illustrations/no-subscribers.svg
var no_subscribers = __webpack_require__(92450);
// EXTERNAL MODULE: ./features/post/components/ShareModal/index.tsx
var ShareModal = __webpack_require__(91822);
;// CONCATENATED MODULE: ./features/publication/components/PublicationPosts/index.tsx









function PublicationPosts(param) {
    var posts = param.posts, publication = param.publication, canFetchMore = param.canFetchMore, handleOnClick = param.handleOnClick, infiniteScrollLoader = param.infiniteScrollLoader, domain = param.domain;
    var handleOnClickShareButton = function handleOnClickShareButton(postId) {
        setModal({
            isOpen: true,
            post: posts.find(function(nextPost) {
                return nextPost.id === postId;
            })
        });
    };
    var ref = (0,react.useState)({
        isOpen: false,
        post: undefined
    }), modal = ref[0], setModal = ref[1];
    var firstPost = posts.length > 0 ? posts[0] : undefined;
    var nextPosts = posts.length > 1 ? posts.slice(1, posts.length) : [];
    if (posts.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(no_subscribers/* default */.Z, {
                    viewBox: "0 0 358 330",
                    className: "max-w-[250px] h-auto mx-auto mb-4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                    className: "text-center m-auto w-1/2 text-2xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "font-bold",
                        children: [
                            "Il n'y a pas d'article...",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Pour le moment !"
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            firstPost && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTeaserBig, {
                post: firstPost,
                publication: publication,
                user: publication.user,
                onClickShare: function(postId) {
                    return handleOnClickShareButton(postId);
                },
                domain: domain
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[768px] p-4 md:p-0 flex flex-col space-y-8 mx-auto mb-16",
                children: [
                    nextPosts === null || nextPosts === void 0 ? void 0 : nextPosts.map(function(post) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTeaser/* default */.Z, {
                            post: post,
                            publication: publication,
                            user: publication.user,
                            onClickShare: function(postId) {
                                return handleOnClickShareButton(postId);
                            },
                            domain: domain
                        }, post.id);
                    }),
                    canFetchMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: infiniteScrollLoader,
                        className: "mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            onClick: handleOnClick,
                            color: "alternative",
                            className: "mt-8 w-fit mx-auto",
                            children: "Charger plus d'articles"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        isOpen: modal.isOpen,
                        closeModal: function() {
                            return setModal({
                                isOpen: false,
                                post: undefined
                            });
                        },
                        children: modal.post && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal/* default */.Z, {
                            post: modal.post,
                            publication: publication
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/publication/components/PublicationStandardPosts/PublicationStandardPosts.service.ts
var pageSize = 10;
function getPostQuery(publicationId, page) {
    return {
        fields: [
            "id",
            "title",
            "subtitle",
            "createdAt",
            "text"
        ],
        populate: {
            actions: {
                filters: {
                    type: "like"
                },
                fields: [
                    "id",
                    "type",
                    "visitorToken"
                ]
            },
            cover: {
                fields: [
                    "url",
                    "provider_metadata"
                ]
            }
        },
        filters: {
            publication: publicationId
        },
        sort: "createdAt:desc",
        pagination: {
            page: page,
            pageSize: pageSize
        }
    };
}

;// CONCATENATED MODULE: ./features/publication/components/PublicationStandardPosts/index.tsx












function PublicationStandardPosts(param) {
    var publication = param.publication, totalPosts = param.totalPosts, posts = param.posts, domain = param.domain;
    var ref = (0,react.useState)(0), activeTab = ref[0], setActiveTab = ref[1];
    var ref1 = (0,react.useState)(2), postsPaginationPage = ref1[0], setPostsPaginationPage = ref1[1];
    var ref2 = (0,react.useState)(posts), nextPosts = ref2[0], setNextPosts = ref2[1];
    var canFetchMore = totalPosts > nextPosts.length;
    function fetchMorePosts() {
        return _fetchMorePosts.apply(this, arguments);
    }
    function _fetchMorePosts() {
        _fetchMorePosts = (0,_async_to_generator/* default */.Z)(function() {
            var query, ref, fetchedPosts, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        query = getPostQuery(publication.id, postsPaginationPage);
                        return [
                            4,
                            (0,post/* getPostsWithInsights */.fo)(query)
                        ];
                    case 1:
                        ref = _state.sent(), fetchedPosts = ref.data;
                        setNextPosts((0,_to_consumable_array/* default */.Z)(nextPosts).concat((0,_to_consumable_array/* default */.Z)(fetchedPosts)));
                        setPostsPaginationPage(postsPaginationPage + 1);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchMorePosts.apply(this, arguments);
    }
    var loader = (0,useInfiniteScroll/* default */.Z)({
        isActive: totalPosts > nextPosts.length,
        fetchMore: fetchMorePosts
    });
    var links = [
        {
            id: 0,
            isActive: activeTab === 0,
            name: "Articles"
        },
        {
            id: 1,
            isActive: activeTab === 1,
            name: "A Propos"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col dark:bg-gray-90 0 min-h-screen",
        children: [
            publication.about && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed top-[58px] lg:top-[92px] xl:top-[92px] w-full bg-white dark:bg-gray-800 border-b dark:border-gray-700 z-10 flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                        links: links,
                        className: "w-full px-3 pt-2",
                        setActiveTab: setActiveTab
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mx-auto ".concat(posts.length > 0 ? "mt-32 md:mt-42 lg:mt-60" : "mt-28 md:mt-32 lg:mt-48", " mb-12"),
                children: [
                    activeTab === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicationPosts, {
                        publication: publication,
                        posts: nextPosts,
                        handleOnClick: function() {
                            return fetchMorePosts();
                        },
                        canFetchMore: canFetchMore,
                        infiniteScrollLoader: loader,
                        domain: domain
                    }),
                    activeTab === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicationAbout, {
                        publication: publication
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeBanner/* default */.Z, {
                publication: publication,
                user: publication.user,
                className: "mt-auto"
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/modules/Layout/StandardLayout/PublicationStandardLayout/index.tsx + 1 modules
var PublicationStandardLayout = __webpack_require__(37844);
// EXTERNAL MODULE: ./components/SchemaOrg/index.tsx
var SchemaOrg = __webpack_require__(77268);
;// CONCATENATED MODULE: ./components/PublicationSlug/index.tsx









function showPublicationPosts(publicationId) {
    return localStorage.getItem((0,publicationLanding_service/* getItemShowPublicationPosts */.p)(publicationId)) === "true";
}
function PublicationSlug(param) {
    var publication = param.publication, posts = param.posts, totalPosts = param.totalPosts, schemaOrgDefinition = param.schemaOrgDefinition, canonicalUrl = param.canonicalUrl, domain = param.domain;
    var ref;
    var ref1 = (0,react.useState)(false), isShowPublicationPosts = ref1[0], setIsShowPublicationPosts = ref1[1];
    (0,react.useEffect)(function() {
        setIsShowPublicationPosts(showPublicationPosts(publication.id));
    }, [
        publication.id
    ]);
    if (!isShowPublicationPosts) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicationLanding, {
            publication: publication,
            setIsShowPublicationPosts: setIsShowPublicationPosts
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PublicationStandardLayout/* default */.Z, {
        publication: publication,
        user: publication.user,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SchemaOrg/* default */.Z, {
                canonical: canonicalUrl,
                definition: schemaOrgDefinition
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* default */.Z, {
                title: publication.title,
                description: publication.description,
                image: (ref = publication.logo) === null || ref === void 0 ? void 0 : ref.url,
                type: "publication",
                url: routes/* default.publicationSlug.getUrl */.Z.publicationSlug.getUrl(publication.slug),
                author: publication.user.pseudoName,
                createdAt: publication.createdAt,
                thematic: publication.thematic
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicationStandardPosts, {
                publication: publication,
                posts: posts,
                totalPosts: totalPosts,
                domain: domain
            })
        ]
    });
}


/***/ }),

/***/ 16169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ContainerMedium; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function ContainerMedium(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container-medium max-w-[768px] mx-auto px-4 md:px-0 ".concat(className),
        children: children
    });
}


/***/ }),

/***/ 87097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BasicLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(370);


function BasicLayout(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("bg-gray-50 dark:bg-gray-900 min-h-screen flex", className),
        children: children
    });
}


/***/ }),

/***/ 94643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Tabs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./lib/classnames.ts
var classnames = __webpack_require__(370);
;// CONCATENATED MODULE: ./components/modules/Navigation/Tabs/TabsChildren/index.tsx


function TabsChildren(param) {
    var isActive = param.isActive, isWarning = param.isWarning, itemId = param.itemId, children = param.children, setActiveTab = param.setActiveTab;
    var onClickHandler = function onClickHandler() {
        setActiveTab(itemId);
    };
    var colorClasses = {
        default: "text-gray-600 dark:text-gray-500 border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300",
        defaultActive: "text-blue-600 border-blue-600 active dark:text-blue-500 dark:border-blue-500",
        warning: "mx-2 border-transparent text-red-800 dark:text-red-500",
        warningActive: "mx-2 text-red-800 border-red-800 dark:text-red-500 dark:border-red-500"
    };
    var colorClass = colorClasses.default;
    if (isActive) {
        colorClass = colorClasses.defaultActive;
    }
    if (isWarning) {
        colorClass = colorClasses.warning;
    }
    if (isWarning && isActive) {
        colorClass = colorClasses.warningActive;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        onClick: onClickHandler,
        className: (0,classnames/* default */.Z)("truncate block p-4 rounded-t-lg border-b-2", colorClass),
        children: children
    });
}

;// CONCATENATED MODULE: ./components/modules/Navigation/Tabs/index.tsx



function Tabs(param) {
    var links = param.links, className = param.className, setActiveTab = param.setActiveTab;
    var onChangeHandler = function onChangeHandler(itemId) {
        setActiveTab(itemId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,classnames/* default */.Z)("md:hidden", className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                    onChange: function(e) {
                        return onChangeHandler(parseInt(e.currentTarget.value, 10));
                    },
                    className: "mb-2 bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                    children: links.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: item.id,
                            children: item.name
                        }, item.id);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "hidden md:flex -mb-px overflow-auto",
                children: links.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsChildren, {
                            itemId: item.id,
                            isActive: item.isActive,
                            isWarning: item.isWarning,
                            setActiveTab: setActiveTab,
                            children: item.name
                        })
                    }, item.id);
                })
            })
        ]
    });
}


/***/ }),

/***/ 85047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useInfiniteScroll; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useInfiniteScroll(param) {
    var _loading = param.loading, loading = _loading === void 0 ? false : _loading, fetchMore = param.fetchMore, _isActive = param.isActive, isActive = _isActive === void 0 ? true : _isActive;
    var observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(node) {
        if (loading || !isActive) {
            return;
        }
        if (observer.current) {
            observer.current.disconnect();
        }
        observer.current = new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                var ref;
                fetchMore();
                (ref = observer.current) === null || ref === void 0 ? void 0 : ref.unobserve(node);
            }
        });
        if (node) {
            observer.current.observe(node);
        }
    }, [
        loading,
        isActive,
        fetchMore
    ]);
}


/***/ })

}]);